import styled from 'styled-components';
import colors from '../../assets/colors';

const Content = styled.div`
  flex: 1;

  .filters {
    display: flex;
    margin-bottom: 25px;
    align-items: center;

    button {
      background: none;
      border: none;
      font-family: 'Open Sans', sans-serif;
      font-size: 0.9rem;
      color: ${colors.primary};
      padding: 5px 0;
      cursor: pointer;

      .fa { margin-right: 8px; margin-bottom: -2px; };
      :hover { opacity: .9; }
      :first-child { margin-right: 25px; }
    }
  }

  .bottom-filter { margin-top: 25px }

  @media screen and (max-width: 419px) {
    .filters {
      flex-direction: column;
      align-items: start;
      margin-bottom: 15px;
      
      button { padding: 10px 5px; }
    }
  }
`;

export default Content;
